import { JobOffer } from "../../JobOffer";
import css from "./styles.module.scss";

export const OneOfferView = ({ offer }) => {

  return (
    <div className={css.OneOfferView}>
      <JobOffer offer={offer} color={"yellow"}/>
    </div>
  );
};
